import { parseCapabilities as t, Capability as e } from "@appfolio/app-capabilities";
var r,
    i = 0;

function n(t) {
  return "__private_" + i++ + "_" + t;
}

function o(t, e) {
  if (!Object.prototype.hasOwnProperty.call(t, e)) throw new TypeError("attempted to use private field on non-instance");
  return t;
}

!function (t) {
  t.INVESTOR = "investor", t.PROPERTY = "property", t.TPORTAL = "tportal", t.NONE = "none";
}(r || (r = {}));

var a = [e.NativeUpload, e.PostMessage],
    p = [e.PostMessage],
    s = n("appType"),
    l = n("capabilities"),
    u = function () {
  function e(e) {
    var i = e.userAgent;
    Object.defineProperty(this, s, {
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, l, {
      writable: !0,
      value: void 0
    }), o(this, s)[s] = r.NONE;

    var n = function (e) {
      var i,
          n = e.match(/.+APMMobileApp-(tportal|property|investor)\/(ios|android)\/([0-9]+)\)/),
          o = null == n ? void 0 : n[3],
          a = null == n ? void 0 : n[2],
          p = null == n ? void 0 : n[1];
      "string" == typeof o && /^\d+$/.test(o) && (i = parseInt(o, 10));
      var s = a,
          l = r.NONE;
      "investor" === p ? l = r.INVESTOR : "property" === p ? l = r.PROPERTY : "tportal" === p && (l = r.TPORTAL);
      var u = null,
          v = t(e);
      return v && (u = v.filter(function (t) {
        return t.enabled;
      }).map(function (t) {
        return t.capability;
      })), [i, s, l, u];
    }(i);

    this.version = n[0], this.platform = n[1], o(this, s)[s] = n[2], o(this, l)[l] = n[3];
  }

  var i;
  return e.prototype.hasCapability = function (t) {
    if (o(this, l)[l]) return o(this, l)[l].includes(t);
    var e = [];
    return o(this, s)[s] === r.PROPERTY ? e = a : o(this, s)[s] === r.TPORTAL && (e = p), !!(this.version && this.version >= 200025 && e.includes(t));
  }, (i = [{
    key: "usingMobileApp",
    get: function get() {
      return !!this.version;
    }
  }]) && function (t, e) {
    for (var r = 0; r < e.length; r++) {
      var i = e[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }(e.prototype, i), e;
}();

export { u as default };